"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ScheduleHighlights() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const scheduleItems = [{
    day: "Day 1",
    date: "14 March 2026",
    caption: "Opening Keynote & Industry Trends"
  }, {
    day: "Day 2",
    date: "15 March 2026",
    caption: "Technical Sessions & Networking"
  }];
  return;
}